@import './fluid-footer.theme.less';

// ================================================================ //
// -- Theme Definition

:host {
  width: 100%;
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-footer {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @footer-tokens: @footer-tokens-legacy;
      @footer();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @footer-tokens: @footer-tokens-lm;
      @footer();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @footer-tokens: @footer-tokens-corp;
      @footer();
    }

    /**
     * LM CORPORATE THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @footer-tokens: @footer-tokens-portal;
      @footer();
    }
  }

  // Placeholder element for fixed-position Footer
  @placeholder();
}


// ================================================================ //
// -- Component Detached Ruleset

@footer: {
  @fixed: @footer-tokens[@fixed];

  display: block;
  font-family: @font-family;
  font-size: @footer-tokens[font-size];
  line-height: @footer-tokens[line-height];
  color: @footer-tokens[color];
  background-color: @footer-tokens[background-color];
  border-style: @border-style;
  border-color: @footer-tokens[border-color];
  border-width: @footer-tokens[border-width] 0 0 0;

  &.footer-fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-width: 0;
    box-shadow: @fixed[box-shadow];
  }
};


// ================================================================ //
// -- Detached Ruleset Helper(s)

@placeholder: {
  .footer-placeholder {
    display: block;
    width: 100%;
  }
}
